<script setup lang="ts">
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { toRefs } from 'vue';
import RelatiegegevensEmbed from '../RelatiegegevensEmbed.vue';

const props = defineProps<{
  relatienummer: number;
}>();

const { relatienummer } = toRefs(props);
</script>

<template>
  <VPageContainer container-size="sm" gap="xs" title="Naselectie">
    <RelatiegegevensEmbed
      :relatienummer="relatienummer"
      :override-src="`/net/relation/NaSelectieList?relatienummer=${relatienummer}&embedMode=1`"
    />
  </VPageContainer>
</template>
